import { createFileRoute } from "@tanstack/react-router";
import CTA from "@/components/LandingPage/CTA";
import BusinessTypes from "@/components/LandingPage/BusinessTypes";
import BusinessTypesShowcase from "@/components/LandingPage/BusinessTypesShowcase";
import CreatorBenefits from "@/components/LandingPage/CreatorBenefits";
import FAQ from "@/components/LandingPage/FAQ";
import Features from "@/components/LandingPage/Features";
// import Hero from "@/components/LandingPage/Hero";
import Hero2 from "@/components/LandingPage/Hero2";
// import Hero3 from "@/components/LandingPage/Hero3";
import HowItWorks from "@/components/LandingPage/HowItWorks";
import ImpactStats from "@/components/LandingPage/ImpactStats";
import LanguageSupport from "@/components/LandingPage/LanguageSupport";
// import Testimonials from "@/components/LandingPage/Testimonials";
import Testimonials2 from "@/components/LandingPage/Testimonials2";
import SafeAndComplient from "@/components/LandingPage/safe-and-complient";
// import { ScrollPromoDialog } from "@/components/providers/scroll-promo-dialog";
import {
  createLLMOMeta,
  createOrganizationSchema,
  createSoftwareApplicationSchema,
} from "@/lib/seo";

const HOME_META_TITLE =
  "Zapify | Instagram Approved Comment & DM Automation Platform";
const HOME_META_DESCRIPTION =
  "Turn Instagram engagement into leads & followers with automated DMs, comment replies, and AI-powered follow-ups. Zapify helps brands, creators, and agencies respond faster and scale conversations.";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      ...createLLMOMeta({
        title: HOME_META_TITLE,
        description: HOME_META_DESCRIPTION,
        url: "https://zapify.pro",
      }),
      {
        name: "keywords",
        content:
          "AI, social media, Instagram, engagement, automation, comment management, content creators, voice, personalized replies",
      },
      {
        property: "og:image",
        content: "https://cms.zapify.pro/uploads/OG_image1_f82f5871e2.png",
      },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      {
        property: "og:image:alt",
        content: HOME_META_TITLE,
      },
      { property: "og:locale", content: "en_US" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://zapify.pro",
      },
      {
        rel: "preload",
        as: "image",
        href: "/mobile-mockup_378w.webp",
        imageSrcSet: "/mobile-mockup_280w.webp 280w, /mobile-mockup_378w.webp 378w",
        imageSizes: "(max-width: 640px) 280px, 350px",
        fetchPriority: "high",
      },
    ],
    scripts: [createOrganizationSchema(), createSoftwareApplicationSchema()],
  }),
  component: App,
});

function App() {
  return (
    <>
      <main className="relative z-10 w-full min-w-0 bg-background">
        {/* <Hero /> */}
        <Hero2 />
        <Testimonials2 />
        <BusinessTypes />
        {/* <Hero3 /> */}
        <ImpactStats />
        <Features />
        <HowItWorks />
        {/* <Testimonials /> */}
        <LanguageSupport />
        <CreatorBenefits />
        {/* <div className="hidden sm:block">
          <BusinessTypesShowcase />
        </div> */}
        <SafeAndComplient />
        <FAQ />
        <CTA />
      </main>
      {/* <ScrollPromoDialog /> */}
    </>
  );
}
